import { useHistory, useLocation } from 'react-router-dom'

import { Banner } from '@loadsmart/miranda-react'

import { getRfpBasePath } from './RfpRoute'

type ReviewAwardedLanesBannerProps = {
  rfpId: string
}

export function ReviewAwardedLanesBanner({ rfpId }: ReviewAwardedLanesBannerProps) {
  const { push: navigate } = useHistory()
  const { pathname } = useLocation()

  function handleReviewClick() {
    navigate(`${getRfpBasePath(pathname)}/${rfpId}/award`)
  }

  return (
    <Banner variant="warning">
      <Banner.Title>{`You have awarded bids. Please review the bids to accept or reject the award.`}</Banner.Title>
      <Banner.Actions>
        <Banner.ActionPrimary onClick={handleReviewClick}>{`Review bids`}</Banner.ActionPrimary>
      </Banner.Actions>
    </Banner>
  )
}
